import React from "react";
import {Box, Typography} from "@mui/material";
import mouthClosedIcon from "./img/mouth_closed_icon.png";
import faceCenteredIcon from "./img/face_centered_icon.png";
import noGlassesIcon from "./img/no_glasses_icon.png";
import MaskSelectorToolStyles from "./MaskSelectorToolStyles";
import {useTranslation} from "react-i18next";

const ScanIconBar = ({ iconSize = 46,
                       faceIconHeight = 54,
                       labelsOnTop = false
                      }) => {

    const { t } = useTranslation("pages.MaskSelectorTool.ScanIconBar");

    const mouthClosed = t("mouthClosed");
    const faceCentered = t("faceCentered");
    const noGlasses = t("noGlasses");

    const {classes} = MaskSelectorToolStyles();

    return (
            <Box className={classes.iconContainerBox}>

                <Box className={classes.iconColumnBox}>
                    { labelsOnTop && (
                        <Typography className={ `${classes.topIconDescTyp} ${classes.res_small_paragraph} ${classes.noOutline}`} tabIndex="0" aria-label={mouthClosed}>{mouthClosed}</Typography>
                    )}
                    <img src={mouthClosedIcon} width={iconSize} height={iconSize}/>
                    { !labelsOnTop && (
                        <Typography className={classes.res_small_paragraph}>{mouthClosed}</Typography>
                    )}
                </Box>


                <Box className={classes.iconColumnBox}>
                    { labelsOnTop && (
                        <Typography className={ `${classes.centerDescTyp} ${classes.res_small_paragraph} ${classes.noOutline}`} tabIndex="0" aria-label={faceCentered}>{faceCentered}</Typography>
                    )}
                    <img src={faceCenteredIcon} width={iconSize} height={faceIconHeight}/>
                    { !labelsOnTop && (
                        <Typography className={ `${classes.centerDescTyp} ${classes.res_small_paragraph}`}>{faceCentered}</Typography>
                    )}
                </Box>

                <Box className={classes.iconColumnBox}>
                    { labelsOnTop && (
                        <Typography className={ `${classes.topIconDescTyp} ${classes.res_small_paragraph} ${classes.noOutline}`} tabIndex="0" aria-label={noGlasses}>{noGlasses}</Typography>
                    )}
                    <img src={noGlassesIcon} width={iconSize} height={iconSize}/>
                    { !labelsOnTop && (
                        <Typography className={classes.res_small_paragraph} >{noGlasses}</Typography>
                    )}
                </Box>

            </Box>
    )
}

export default ScanIconBar;